<template>
  <div :id="this.$route.name">
    <div Id="fullpage" @click="cancelgallery">
      <img id="gallery" class="rounded" :src="gellery" />
    </div>
    <Card back>
      <template v-slot:header>
        <h3>جستجوی مشتـــریان</h3>
        <hr />
      </template>
      <template v-slot:content>
        <form @submit.prevent="this.$ValidForm(this)" autocomplete="off">
          <div class="text-center mr-2 ml-2">
            <div class="position-relative" :class="ThemeTitleModal">
              <div v-if="$route.params.Status == 'Edit'" class="dropdown position-absolute d-none d-sm-block" style="left: 5px; bottom: 10px">
                <!-- <button class="btn text-warning bg-transprent" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-list" style="font-size: 20px !important"></i>
                </button> -->
                <b-dropdown size="md" variant="link" class="d-inline text-danger text-center" toggle-class="text-decoration-none " no-caret>
                  <template #button-content
                    ><h4><i class="fad fa-stream text-secondary"></i></h4
                  ></template>
                  <b-dropdown-item href="#" class="text-center" @click="AzaPasAndJari(EditData)">حسابها</b-dropdown-item>
                  <b-dropdown-item href="#" class="text-center" @click="AzaTashilat(EditData)">تسهیلات</b-dropdown-item>
                  <!-- <b-dropdown-item href="#" class="text-center" @click="AzaDlgsms(EditData)"> پیامک ها </b-dropdown-item> -->
                  <b-dropdown-item href="#" class="text-center" @click="AzaHesabha(EditData.Id)"> حسابهای بانکی </b-dropdown-item>
                </b-dropdown>
              </div>
              <!-- <ul class="nav nav-tabs mt-3" id="myTab" role="tablist" dir="rtl">
                <li class="nav-item">
                  <a class="nav-link active" id="Detail-tab" data-toggle="tab" href="#EtelaatAvaliye" role="tab" aria-controls="EtelaatAvaliye" aria-selected="true">
                    <span class="fas fa-globe ml-2" style="color: #f38905"></span>
                    <span>اطلاعات عمومی</span></a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="Detail-tab" data-toggle="tab" href="#Sayer" role="tab" aria-controls="Sayer" aria-selected="true">
                    <span class="far fa-address-card ml-2" style="color: #f38905"></span>
                    <span>سایر اطلاعات</span></a
                  >
                </li>
              </ul> -->
            </div>
            <tab :tab="Tablist" v-if="renderTab == true">
              <template v-slot:content0>
                <div class="tab-pane fade show active pr-2 pt-2 pb-2" id="EtelaatAvaliye" role="tabpanel" aria-labelledby="Detail-tab">
                  <div class="row" dir="">
                    <div class="col-md-3 col-12 text-center mt-3 border-left">
                      <b-carousel id="carousel-1" :interval="4000" controls indicators style="text-shadow: 1px 1px 2px #333">
                        <b-carousel-slide img-blank>
                          <div class="profile_pic1 mt-3">
                            <img v-if="temp" @click="showimage($event)" :src="temp" alt="..." class="img-circle profile_img1 Pointer" @change="console.error('change', this.src)" id="profile_img" />
                            <img v-else src="/img/pic/MoshtariPic.jpg" alt="..." class="img-circle profile_img1" @change="console.error('change', this.src)" id="profile_img" />
                          </div>
                          <div class="mt-2">
                            <a :disabled="!InputActive" href=""><span class="badge badge-Orange p-1 font-weight-normal" @click.prevent="Openuploader('TblCashImageIdPic')">آپلود تصویر</span></a>
                            <input type="file" accept="image/*," class="d-none uploader" id="TblCashImageIdPic" @change="$uploadInImg($event, 'profile_img', 'TblCashImageIdPic')" />
                            <!-- <input type="text" id="TblCashImageIdPic" class="d-none uploader" /> -->
                            <a :disabled="!InputActive" @click="OpenModal(3)"><span class="badge badge-success p-1 mr-1 font-weight-normal">وبکم | دوربین</span></a>
                            <!-- <div class="badge badge-success w-100 font-weight-normal"><span class="fas fa-camera-retro" style="font-size:17px !important;" ></span><span class="mr-2">وبــکم | دوربین</span></div>
                                                            <div class="badge badge-Orange w-100 mt-2 font-weight-normal"><span class="fa fa-upload" style="font-size:17px !important;" ></span> <span class="mr-2">آپلـــود</span></div> -->
                          </div>
                        </b-carousel-slide>
                        <b-carousel-slide img-blank>
                          <div class="profile_pic1 mt-3">
                            <img v-if="temp2" :src="temp2" @click="showimage($event)" alt="..." class="img-circle profile_img1 Pointer" @change="console.error('change', this.src)" id="Signature_img" />
                            <img v-else src="/img/pic/signature-logo_2.jpg" alt="..." class="img-circle profile_img1" id="Signature_img" />
                          </div>
                          <div class="mt-2">
                            <span :disabled="!InputActive" class="badge badge-Orange p-1 font-weight-normal" @click.prevent="Openuploader('TblCashImageIdEmza1')">آپلود تصویر</span>
                            <!-- <a
                              :disabled="!InputActive"
                              @click="
                                changelightpen()
                                OpenModal(2)
                              "
                              ><span class="badge badge-info p-1 mr-1 font-weight-normal"> قلم نوری </span></a
                            > -->
                            <a :disabled="!InputActive" @click="OpenModal(1)"><span class="badge badge-success p-1 mr-1 font-weight-normal"> وبـکم </span></a>
                            <input type="file" id="TblCashImageIdEmza1" accept="image/*," class="d-none uploader" @change="$uploadInImg($event, 'Signature_img', 'TblCashImageIdEmza1')" />
                            <!-- <input type="text" id="TblCashImageIdEmza1" class="d-none uploader" /> -->

                            <!-- <div class="badge badge-success w-100 font-weight-normal"><span class="fas fa-camera-retro" style="font-size:17px !important;" ></span><span class="mr-2">وبــکم | دوربین</span></div>
                                                            <div class="badge badge-Orange w-100 mt-2 font-weight-normal"><span class="fa fa-upload" style="font-size:17px !important;" ></span> <span class="mr-2">آپلـــود</span></div> -->
                          </div>
                        </b-carousel-slide>
                        <!-- </div> -->
                        <!-- <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                          <span class="fas fa-angle-left text-danger mr-5" style="font-size: 22px !important" aria-hidden="true"></span>
                          <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                          <span class="fas fa-angle-right text-danger ml-5" style="font-size: 22px !important" aria-hidden="true"></span>
                          <span class="sr-only">Next</span>
                        </a> -->
                      </b-carousel>
                    </div>
                    <div class="col-md-9 col-12">
                      <div class="row mt-2">
                        <div class="col-md-4 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-center mt-3">
                              <div class="">
                                <span class="font-weight-bold fas fa-user ml-2" style="font-size: 16px !important; color: #d17906"></span>
                                <span class="font-weight-bold" style="font-size: 16px !important">شمــــاره مشتــــری </span>
                                <span class="font-weight-bold d-block" style="font-size: 16px !important" dir="rtl"> {{ DataAxios.ShomareOzv }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small>مالکیت</small>
                              <SearchableCombo
                                :edit="false"
                                :grp="11"
                                :defaultvalue="DataAxios.TblComboIdMalekiat24"
                                @ResultCombo="ValueResultMalekiat"
                                :queryString="{ id: 24 }"
                                :rownumintable="3"
                                :action="'TblCombo/GettblCombo'"
                                :method="'GET'"
                                :idinput="'Malekiat'"
                                :keyItem="'Malekiat'"
                                :disabled="!InputActive"
                                :IsDefault="true"
                              >
                              </SearchableCombo>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-md-4 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small id="OzvName" v-if="Malekiat == 4088 || Malekiat == 5738">نام</small>
                              <small id="OzvName" v-if="Malekiat == 4089 || Malekiat == 4090">عنوان</small>
                              <input :disabled="!InputActive" @keypress="$ValidPersian($event, 20)" type="text" id="OzvName" class="form-control InputText required" v-model="DataAxios.OzvName" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small id="OzvFamily" v-if="Malekiat == 4088 || Malekiat == 5738">نام خانوادگی</small>
                              <small id="OzvFamily" v-if="Malekiat == 4089">نام حقوقی</small>
                              <small id="OzvFamily" v-if="Malekiat == 4090">نام مشترک</small>
                              <input :disabled="!InputActive" @keypress="$ValidPersian($event, 40)" type="text" id="OzvFamily" class="form-control InputText required" v-model="DataAxios.OzvFamily" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small id="CodeMeli" v-if="Malekiat == 4089">شناسه ملی</small>
                              <small id="CodeMeli" v-else>کد ملی</small>
                              <input :disabled="!InputActive" type="text" maxlength="10" class="form-control InputText required required-CodeMeli text-left" @keypress="$ValidNumber($event, 10)" @input="$CheckupLengthCodeMeli($event)" v-model="DataAxios.CodeMeli" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-md-4 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small id="Shenasname" v-if="Malekiat == 4089">کد حقــوقی</small>
                              <small id="Shenasname" v-else-if="Malekiat == 4090">کد مشتــرک</small>
                              <small id="Shenasname" v-else>شماره شناسنامه</small>
                              <input :disabled="!InputActive" type="text" maxlength="10" @keypress="$ValidNumber($event, 10)" v-model="DataAxios.Shenasname" id="Shenasname" class="form-control InputText" style="direction: ltr" />
                            </div>
                          </div>
                        </div>
                        <div v-if="Malekiat != 4089" class="col-md-4 col-12 text-right">
                          <small>نام پدر</small>
                          <input :disabled="!InputActive || Malekiat == 4089" v-model="DataAxios.Pedar" type="text" @keypress="$ValidPersian($event, 50)" id="NetDomain" class="form-control text-right InputText" style="direction: ltr" />
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small>شماره همراه</small>
                              <input :disabled="!InputActive" type="text" @keypress="$ValidNumber($event, 11)" id="NetServer" class="form-control InputText" style="direction: ltr" v-model="DataAxios.Mobile" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-12">
                      <div class="row mt-4">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small>آدرس منزل</small>
                              <textarea :disabled="!InputActive" type="text" id="NetServer" class="form-control text-right InputText" rows="1" style="direction: ltr" v-model="DataAxios.Adres"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-right">
                          <small>تلفن منزل</small>
                          <input :disabled="!InputActive" type="text" @keypress="$ValidNumber($event, 11)" id="NetDomain" class="form-control InputText" style="direction: ltr" v-model="DataAxios.Tel" />
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small>آدرس محل کار</small>
                              <textarea :disabled="!InputActive" type="text" id="NetServer" class="form-control InputText text-right" rows="1" style="direction: ltr" v-model="DataAxios.MahalKar"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-right">
                          <small>تلفن محل کار</small>
                          <input :disabled="!InputActive" type="text" @keypress="$ValidNumber($event, 11)" id="NetDomain" class="form-control InputText" style="direction: ltr" v-model="DataAxios.InternalTel" />
                        </div>

                        <div class="col-md-3 col-12">
                          <div class="row">
                            <div class="mt-4 col-md-12 col-12 text-right">
                              <small>حوزه</small>

                              <SearchableCombo
                                :edit="false"
                                :grp="11"
                                :IsDefault="true"
                                :defaultvalue="DataAxios.TblAzaNoeId"
                                @ResultCombo="ValueResultHoze"
                                :queryString="{ id: $session.get('UserInfo').tblShobeId }"
                                :rownumintable="3"
                                :action="'TblCombo/GetHoze'"
                                :method="'GET'"
                                :idinput="'Hoze'"
                                :keyItem="'Hoze'"
                                :disabled="!InputActive"
                              >
                              </SearchableCombo>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12">
                          <div class="row">
                            <div class="mt-4 col-md-12 col-12 text-right">
                              <small>وضعیت</small>
                              <SearchableCombo
                                :edit="false"
                                :defaultvalue="DataAxios.TblComboIdVazeit12"
                                :grp="11"
                                :IsDefault="true"
                                @ResultCombo="ValueResultVaziat"
                                :queryString="{ id: 12 }"
                                :rownumintable="3"
                                :action="'TblCombo/GettblCombo'"
                                :method="'GET'"
                                :idinput="'Vaziat'"
                                :keyItem="'Vaziat'"
                                :disabled="!InputActive"
                              >
                              </SearchableCombo>
                            </div>
                          </div>
                        </div>
                        <div class="mt-4 col-md-3 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small>نوع مشتری</small>
                              <!-- <combo
                                  :IsDisabled="!InputActive"
                                  :IsDefault="true"
                                  @ValueResult="ValueResultNoeMoshtari"
                                  :IsLoad="true"
                                  :ActionUrl="'GettblTafsiliType'"
                                  :IdEditMode="DataAxios.TblTafsiliTypeId"
                                  :Params="$session.get('UserInfo').tblShobeId"
                                  :Op_TextDefult="'حوزه را انتخاب کنید'"
                                ></combo> -->

                              <SearchableCombo
                                :edit="false"
                                :grp="11"
                                :IsDefault="true"
                                @ResultCombo="ValueResultNoeMoshtari"
                                :defaultvalue="DataAxios.TblTafsiliTypeId"
                                :queryString="{ id: $session.get('UserInfo').tblShobeId }"
                                :rownumintable="3"
                                :action="'TblCombo/GettblTafsiliType'"
                                :method="'GET'"
                                :idinput="'NoeMoshtari'"
                                :keyItem="'NoeMoshtari'"
                                :disabled="!InputActive"
                              >
                              </SearchableCombo>
                            </div>
                          </div>
                        </div>
                        <div v-if="Malekiat == 4088 || Malekiat == 5738 ? true : false" class="mt-4 col-md-3 col-12">
                          <div class="row">
                            <div class="col-md-12 col-12 text-right">
                              <small>جنسیت</small>
                              <!-- <combo @ValueResult="ValueResultSex" :IsDisabled="(InputActive && Malekiat == 4088) || Malekiat == 5738 ? false : true" :IdEditMode="DataAxios.TblComboIdSex13" :IsLoad="true" :ActionUrl="'GettblCombo'" :Params="13" :Op_TextDefult="'جنسیت را انتخاب کنید'"></combo> -->
                              <SearchableCombo
                                :edit="false"
                                :grp="11"
                                :IsDefault="true"
                                @ResultCombo="ValueResultSex"
                                :defaultvalue="DataAxios.TblComboIdSex13"
                                :queryString="{ id: 13 }"
                                :rownumintable="3"
                                :action="'TblCombo/GettblCombo'"
                                :method="'GET'"
                                :idinput="'Sex'"
                                :keyItem="'Sex'"
                                :disabled="(InputActive && Malekiat == 4088) || Malekiat == 5738 ? false : true"
                              >
                              </SearchableCombo>
                            </div>
                          </div>
                        </div>

                        <div class="mt-4 col-md-3 col-12 text-right">
                          <small>محل صدور</small>
                          <!-- <combo @ValueResult="ValueResultMahalsodor" :IsDisabled="!InputActive" :IsLoad="true" :ActionUrl="'GettblCombo'" :IdEditMode="DataAxios.TblComboIdMahalSodor11" :Params="11" :Op_TextDefult="'محل صدور را انتخاب کنید'"></combo> -->
                          <SearchableCombo
                            :edit="false"
                            :grp="11"
                            :IsDefault="true"
                            :defaultvalue="DataAxios.TblComboIdMahalSodor11"
                            @ResultCombo="ValueResultMahalsodor"
                            :queryString="{ id: 11 }"
                            :rownumintable="3"
                            :action="'TblCombo/GettblCombo'"
                            :method="'GET'"
                            :idinput="'Mahalsodor'"
                            :keyItem="'Mahalsodor'"
                            :disabled="!InputActive"
                          >
                          </SearchableCombo>
                        </div>
                        <div v-if="Malekiat == 4089 ? false : true" class="mt-4 col-md-3 col-12 text-right">
                          <small>تاهل</small>
                          <!-- <combo @ValueResult="ValueResultTaahol" :IsDisabled="!InputActive" :IsLoad="true" :IdEditMode="DataAxios.TblComboIdTahol19" :ActionUrl="'GettblCombo'" :Params="19" :Op_TextDefult="'تاهل را انتخاب کنید'"></combo> -->
                          <SearchableCombo
                            :edit="false"
                            :grp="11"
                            :IsDefault="true"
                            :defaultvalue="DataAxios.TblComboIdTahol19"
                            @ResultCombo="ValueResultTaahol"
                            :queryString="{ id: 19 }"
                            :rownumintable="3"
                            :action="'TblCombo/GettblCombo'"
                            :method="'GET'"
                            :idinput="'Taahol'"
                            :keyItem="'Taahol'"
                            :disabled="!InputActive"
                          >
                          </SearchableCombo>
                        </div>

                        <div class="mt-4 col-md-3 col-12">
                          <div class="row">
                            <div :disabled="!InputActive" class="col-md-12 col-12 text-center">
                              <small v-if="Malekiat == 4088 || Malekiat == 5738">تاریخ تولد</small>
                              <small v-else>تاریخ ثبت</small>
                              <date-picker :editable="true" v-model="DataAxios.BirthDate" color="dimgray"></date-picker>
                              <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
                            </div>
                          </div>
                        </div>
                        <div class="mt-4 col-md-3 col-12">
                          <div class="row">
                            <div :disabled="!InputActive" class="col-md-12 col-12 text-right">
                              <small>تاریخ عضویت</small>
                              <date-picker :editable="true" v-model="DataAxios.TarixOzv" color="dimgray"></date-picker>
                              <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
                            </div>
                          </div>
                        </div>
                        <div class="mt-4 col-md-6 col-12"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-right" v-if="$route.params.Status == null">
                    <button-save-data class="mb-3 mr-2" :ShowCancelButton="true" :DataParanet="DataAxios"></button-save-data>
                  </div>
                  <div class="text-right" v-if="$route.params.Status == 'Edit' && InputActive">
                    <button-edit-data class="mb-3 mr-2" :DataParanet="DataAxios"></button-edit-data>
                  </div>
                  <div v-if="!InputActive">
                    <div id="ShowEditbtn" class="mt-3 text-right animate__animated animate__fadeInDown">
                      <button class="btn btn-success mr-1" dir="ltr" @click.prevent="changeMode()">
                        <i class="mr-2"> اصلاح</i>
                        <i class="fas fa-edit"></i>
                      </button>
                      <button class="btn btn-outline-danger mr-1" dir="ltr" @click.prevent="DeleteAza()">
                        <i class="mr-2"> حذف مشتری </i>
                        <i class="fas fa-trash"></i>
                      </button>
                      <!-- <button id="btnCancel" class="btn btn-info-hover-reverse mr-1" dir="ltr" @click.prevent="Back()">
                        <span class="mr-2">بازگشت</span>
                        <span class="fa fa-reply"></span>
                      </button> -->
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:content1>
                <div class="tab-pane fade show position-relative" id="Sayer" role="tabpanel" aria-labelledby="Detail-tab">
                  <div class="row mt-2 text-right" dir="">
                    <div class="col-md-2 col-12">
                      <small>نام لاتین</small>
                      <input :disabled="!InputActive" type="text" @keypress="$Validengilsh($event, 20)" id="NetServer" class="form-control InputText" style="direction: ltr" v-model="DataAxios.NameLatin" />
                    </div>
                    <div class="col-md-2 col-12">
                      <small>سریال شناسنامه</small>
                      <input :disabled="!InputActive" type="text" @keypress="$ValidNumber($event, 10)" id="NetServer" class="form-control InputText" style="direction: ltr" v-model="DataAxios.SerialShenasname" />
                    </div>
                    <div class="col-md-2 col-12">
                      <small>کد پستی</small>
                      <input :disabled="!InputActive" type="text" @keypress="$ValidNumber($event, 10)" id="NetServer" class="form-control InputText" style="direction: ltr" v-model="DataAxios.Codeposti" />
                    </div>
                    <div :disabled="!InputActive" class="col-md-2 col-12">
                      <small v-if="Malekiat == 4088 || Malekiat == 5738">تاریخ استخدام</small>
                      <small v-else>تاریخ راه اندازی</small>
                      <date-picker :editable="true" v-model="DataAxios.TarixEmp" color="dimgray"></date-picker>
                      <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
                    </div>

                    <div class="col-md-2 col-12">
                      <small>شماره نمابر</small>
                      <input :disabled="!InputActive" type="text" @keypress="$ValidNumber($event, 11)" id="NetServer" class="form-control InputText" style="direction: ltr" v-model="DataAxios.NamabarNo" />
                    </div>
                    <div class="col-md-2 col-12">
                      <small>شماره پرونده</small>
                      <input :disabled="!InputActive" type="text" @keypress="$ValidNumber($event, 12)" id="NetServer" class="form-control InputText" style="direction: ltr" v-model="DataAxios.Parvandeh" />
                    </div>
                    <div class="col-md-6 col-12 mt-3">
                      <small>توضیحات</small>
                      <textarea :disabled="!InputActive" type="text" id="NetServer" class="form-control InputText" rows="1" style="direction: ltr" v-model="DataAxios.DesOzv"> </textarea>
                    </div>
                    <div class="col-md-3 col-12 mt-3">
                      <small>تحصـیلات</small>
                      <!-- <combo @ValueResult="ValueResultTahsilat" :IsDisabled="!InputActive" :IsLoad="true" :ActionUrl="'GettblCombo'" :Params="316" :Op_TextDefult="' تحصیلات را انتخاب کنید'"></combo> -->
                      <SearchableCombo
                        :edit="false"
                        :grp="11"
                        :defaultvalue="DataAxios.TblComboIdTahsilat316"
                        :IsDefault="true"
                        @ResultCombo="ValueResultTahsilat"
                        :queryString="{ id: 316 }"
                        :rownumintable="3"
                        :action="'TblCombo/GettblCombo'"
                        :method="'GET'"
                        :idinput="'Tahsilat'"
                        :keyItem="'Tahsilat'"
                        :disabled="!InputActive"
                      >
                      </SearchableCombo>
                    </div>
                    <div class="col-md-3 col-12 mt-3">
                      <small>شغـل</small>
                      <!-- <combo @ValueResult="ValueResultJob" :IsDisabled="!InputActive" :IsLoad="true" :ActionUrl="'GettblJob'" :Params="null" :Op_TextDefult="'شغل را انتخاب کنید'"></combo> -->
                      <SearchableCombo :edit="false" :grp="11" :defaultvalue="DataAxios.TblJobsId" :IsDefault="true" @ResultCombo="ValueResultJob" :rownumintable="3" :action="'TblCombo/GettblJob'" :method="'GET'" :idinput="'Job'" :keyItem="'Job'" :disabled="!InputActive"> </SearchableCombo>
                    </div>
                    <div class="col-md-3 col-12 mt-3">
                      <small>مجوز معرفی</small>
                      <span class="form-control p-1">
                        <div class="custom-control custom-switch">
                          <input :disabled="!InputActive" type="checkbox" v-model="DataAxios.Moaref" class="custom-control-input InputText" id="Moaref" />
                          <label class="custom-control-label" for="Moaref">مجاز به معرفی</label>
                        </div>
                      </span>
                    </div>
                    <div class="col-md-3 col-12 mt-3">
                      <small>مجوز ضمانت</small>
                      <span class="form-control p-1">
                        <div class="custom-control custom-switch">
                          <input :disabled="!InputActive" type="checkbox" v-model="DataAxios.Zamen" class="custom-control-input InputText" id="Zamen" />
                          <label class="custom-control-label" for="Zamen">مجاز به ضمانت</label>
                        </div>
                      </span>
                    </div>
                    <div class="col-md-3 col-12 mt-3">
                      <small>مجوز عضویت</small>
                      <span class="form-control p-1">
                        <div class="custom-control custom-switch">
                          <input :disabled="!InputActive" type="checkbox" v-model="DataAxios.Aza" class="custom-control-input InputText" id="Aza" />
                          <label class="custom-control-label" for="Aza">مجاز به عضویت</label>
                        </div>
                      </span>
                    </div>
                    <div class="col-md-3 col-12 mt-3">
                      <small>مجوز ارسال پیامک</small>
                      <span class="form-control p-1">
                        <div class="custom-control custom-switch">
                          <input :disabled="!InputActive" type="checkbox" v-model="DataAxios.SendSmsForHim" class="custom-control-input InputText" id="SendSmsForHim" />
                          <label class="custom-control-label" for="SendSmsForHim">ارسال پیامک برای شخص</label>
                        </div>
                      </span>
                    </div>
                    <div :disabled="!InputActive" class="col-md-3 col-12 mt-3">
                      <small>تاریخ انقضای ارسال پیامک</small>
                      <date-picker :editable="true" color="dimgray"></date-picker>
                      <input tabindex="-1" type="text" v-model="DataAxios.LastSmsengheza" id="tarixTasis" class="d-none InputText" style="direction: ltr" />
                    </div>

                    <div v-if="$route.params.Status == null" class="col-md-3 col-12 mt-3">
                      <small>افتتاح حساب </small>
                      <select class="form-control">
                        <option>-- حساب مورد نظر را انتخاب کنید--</option>
                      </select>
                    </div>
                    <div v-if="$route.params.Status == null" class="col-md-3 col-12 mt-3">
                      <small>مبلغ افتتاح حساب</small>
                      <input type="text" v-model="DataAxios.MablaghEftetehHesabAza" @keypress="$ValidNumber($event, 12)" id="NetServer" class="form-control InputText" style="direction: ltr" />
                    </div>
                  </div>
                  <!-- <div class="text-right bg-danger" v-if="$route.params.Status == null">
                    <button-save-data class="mb-3 mr-2" :DataParanet="DataAxios"></button-save-data>
                  </div> -->
                  <div class="text-right" v-if="$route.params.Status == 'Edit' && InputActive">
                    <button-edit-data class="mb-3 mr-2" :DataParanet="DataAxios"></button-edit-data>
                  </div>
                  <div v-if="!InputActive">
                    <div id="ShowEditbtn" class="mt-3 text-right animate__animated animate__fadeInDown">
                      <button class="btn btn-success mr-1" dir="ltr" @click.prevent="changeMode()">
                        <i class="mr-2"> اصلاح</i>
                        <i class="fas fa-edit"></i>
                      </button>
                      <button class="btn btn-outline-danger mr-1" dir="ltr" @click.prevent="DeleteAza()">
                        <i class="mr-2"> حذف مشتری </i>
                        <i class="fas fa-trash"></i>
                      </button>
                      <!-- <button id="btnCancel" class="btn btn-info-hover-reverse mr-1" dir="ltr" @click.prevent="Back()">
                        <span class="mr-2">بازگشت</span>
                        <span class="fa fa-reply"></span>
                      </button> -->
                    </div>
                  </div>
                  <!-- <div><button-save-data class="mb-3 mr-2"></button-save-data></div> -->
                </div>
              </template>
              <div class="tab-pane fade show" id="Hellp" role="tabpanel" aria-labelledby="Hellp">
                <div class="mt-2 mb-2 alert alert-secondary">[بعد از فعال کردن گزینه مورد نظر ، سیستم به صورت خودکار اطلاعات را ذخیره می کند.]</div>
              </div>
            </tab>
          </div>
        </form>
      </template>
    </Card>
    <Modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
      <template v-slot:body v-if="ModalSelect == 1">
        <div class="container text-right">
          <div class="row pl-2 pr-2 mt-2">
            <div class="col-12">
              <WebCame :iduploader="'TblCashImageIdEmza1'" :idshowimg="'Signature_img'"></WebCame>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body v-else-if="ModalSelect == 2">
        <div class="container text-right">
          <div class="row pl-2 pr-2 mt-2">
            <span class="badge badge-TurnOn-Webcam font-weight-normal w-100"><i class="fas fa-camera-retro ml-2"></i> با استفاده از <span class="badge badge-info font-weight-normal"> قلم نوری </span>امضای خود را وارد </span>
            <div style="padding: 5px; width: 100%">
              <LightPen :Actived="lightpenactive" :iduploader="'TblCashImageIdEmza1'" :idshowimg="'Signature_img'"></LightPen>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body v-else-if="ModalSelect == 3">
        <div class="container text-right">
          <div class="row pl-2 pr-2 mt-2">
            <div class="col-12">
              <!-- <test-web-came  :iduploader="'TblCashImageIdEmza1'" :idshowimg="'Signature_img'"></test-web-came> -->
              <WebCame :iduploader="'TblCashImageIdPic'" :idshowimg="'profile_img'"></WebCame>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import ButtonSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Tab from '@/components/Tab/Tab.vue'

// import Combo from '../../../Tools/Combo.vue'
// import ModalCustom from '../../../Tools/ModalCustom.vue'
import Modal from '@/pages/Modal/Modal.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import WebCame from '@/components/BnpCash/Devices/WebCam.vue'
import LightPen from '@/components/BnpCash/Devices/LightPen.vue'
import ButtonEditData from '@/components/BnpButtons/BtnEditData.vue'
export default {
  components: {
    Tab,
    Card,
    datePicker: VuePersianDatetimePicker,
    ButtonSaveData,
    SearchableCombo,
    Modal,
    WebCame,
    LightPen,
    ButtonEditData,
  },
  data() {
    return {
      Tablist: [
        { header: 'اطلاعات عمومی', active: true },
        { header: 'سایر اطلاعات', active: false },
      ],
      renderTab: true,
      Data: {
        Id: 5,
        TblShobeId: 1,
        TblTafsiliTypeId: 100423,
        TblUserIdHamkar: null,
        TblCashImageIdPic: 0,
        TblCashImageIdEmza1: 0,
        TblCashImageIdEmza2: null,
        TblCashImageIdEmza3: null,
        TblAzaNoeId: 100422,
        ShomareOzv: '',
        OzvName: '',
        OzvFamily: '',
        Pedar: '',
        Shenasname: 0,
        TblComboIdMahalSodor11: null,
        CodeMeli: '',
        MahalKar: '',
        Adres: '',
        Tel: '',
        NamabarNo: 0,
        Mobile: '',
        TarixOzv: '1400/08/08',
        TblComboIdVazeit12: 4036,
        Aza: true,
        Zamen: true,
        Moaref: true,
        MablaghMojazMoaref: null,
        TedadSahm: 150.0,
        DesOzv: 'توضيحات',
        Ghayem: null,
        LastScore: null,
        LastYearScore: null,
        LastUpdateScore: null,
        PerNo: null,
        TblComboIdSex13: 4041,
        Arzesh: 0,
        WebPss: 'ug2FvJ+Y7Ow=',
        BirthDate: '',
        SumBedeh: null,
        SumBestan: null,
        SumTotal: null,
        SumGhest: null,
        TblComboIdTahol19: 4067,
        Takafol: 0,
        TarixEmp: '',
        MobBl: false,
        InternalTel: 0,
        NotInAward: false,
        ZamanInsert: '',
        TblUserGrpIdInsert: 1,
        TblUserGrpIdLastEdit: 1,
        ZamanLastEdit: '',
        PicOzvId: null,
        PicEmzaId: null,
        InfoDes: null,
        LastSmstavalod: null,
        MablaghEftetehHesabAza: 0.0,
        TblNoeIdAutoOpenAza: 0,
        TblComboIdMalekiat24: 4088,
        NameFamily: '',
        WwwHasBeenChanged: true,
        WwwtblAzaId: 0,
        Email: '',
        Parvandeh: '',
        AxarinVorodBeSite: null,
        AxarinTaghirPass: null,
        SkinName: null,
        DaryaftEmailSoratHesabMah: false,
        DaryaftEmailTabloElanat: false,
        SmsdarPar: false,
        SmsvorodBeSite: false,
        TaghirTavasotOzv: false,
        SerialShenasname: '',
        NotInTaghsimMablagh: false,
        SendSmsForHim: true,
        AdamGozareshGiriZobAhan: false,
        Codeposti: 0,
        IsWebPssEncrypted: true,
        CodeErtebatiBank: 0,
        HasBeenMobileChanged: true,
        MobileBankPassword: 'ug2FvJ+Y7Ow=',
        SmstblMobileId: null,
        SmsHasBeenChanged: true,
        SmstblAzaId: null,
        ArzeshHarSahm: null,
        TarixBazneshastegi: '',
        NetServer: '',
        NetDomain: '',
        NetUserName: '',
        NetEmail: '',
        IsActiveDirectoryUser: false,
        AtbaKhareje: false,
        IsModirSamaneh: false,
        NameLatin: '',
        ExpireDateSendSms: '',
        TelBankPas: '',
        TblComboIdTahsilat316: null,
        Job: '',
        EmkanRequestVamForAll: false,
        MinHoghoghDaryafti: 0.0,
        TblCashImageIdFinger: 0,
        HamrahBankPass: 'ug2FvJ+Y7Ow=',
        CodeRahgiriXaridHamrahBank: null,
        TarixXaridHamrahBank: null,
        MablaghXaridHamrahBank: null,
        VameDigarMarakez: 0.0,
        MablaghEslahi: 0.0,
        VamGdaryaft: 0.0,
        VamGghest: 0.0,
        CodeErtebati: null,
        Custgroohid: null,
        Moavenatid: null,
        Edareid: null,
        CartNo: null,
        LastSmsengheza: null,
        TblUserId: 1,
        AzShomareSahm: 0,
        TaShomareSahm: 0,
        VamDaryaftiKarajEsfahan: 0.0,
        CartTaradod: 0,
        VamDaryaftiKarjEsfahan: null,
        SumMan: 0.0,
        SoodSaham: 0.0,
        SanadEslahi: null,
        MablaghSaham: 0.0,
        WebUserNameAfterChange: null,
        WebPssAfterChange: null,
        HamrahBankUserNameAfterChange: null,
        HamrahBankPassAfterChange: null,
        IsTrueMobile: false,
        SumBedehiBeDigaran: 0.0,
        CodeMoaref: 14,
        BajePass: 'rUEMhTFwP0c=',
        TblGrpIdSemat: 100431,
        SaghfTaeidDarxastVamDarSal: 5000000.0,
        IsPrintSana: true,
        TblAzaGharardad: [],
        TblAzaHesab: [],
        TblAzaHoghoghi: [],
        TblAzaMessage: [],
        TblAzaTakafol: [],
        TblErrorList: [],
        TblMoarefiBeSazman: [],
        TblNeedVam: [],
        TblSahebanHesabTblAza: [],
        TblSahebanHesabTblAzaIdSahebHesabNavigation: [],
        TblSanadRiz: [],
        TblSanadRizMovaghat: [],
        TblSepSood: [],
        TblTaahodat: [],
        TblTaahodatRiz: [],
        TblTaghsimMablagh: [],
        TblTanzimatXaridDeyn: [],
        TblVarizRiz: [],
        TblZamenVaMoaref: [],
      },
      ModalSelect: 0,
      DataAxios_GetImg: {
        ArryfildValue: {},
        Method: 'POST',
        Action: '',
        Token: this.$session.get('Token'),
      },
      Malekiat: null,
      DataAxios: null,
      lightpenactive: false,
      EditDataD: this.EditData,
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: 'Get',
        Action: '',
        Token: this.$session.get('Token'),
      },
      temp: null,
      temp2: null,
      InputActive: true,
      ShomareOzv: '',
      gellery: null,
      DataAxiosDelete: {
        ArryfildValue: '',
        Method: 'Delete',
        Action: 'AzaInfo',
        Token: this.$session.get('Token'),
      },
      Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
    }
  },
  computed: {
    ThemeTitleModal() {
      return this.$store.state.ThemeModal
    },
    IdPic() {
      if (this.EditData.TblCashImageIdPic != null) {
        return true
      } else return false
    },
    EmzaPic() {
      if (this.EditData.TblCashImageIdEmza1 != null) {
        return true
      } else return false
    },
  },
  created() {
    this.AcceessButton(this.$route.name)
    localStorage.removeItem('my-screen')
    if (this.$route.params.Status == null) {
      let DataAxios_GetShomareOzv = {
        ArryfildValue: { tblshobeId: this.$session.get('UserInfo').tblShobeId },
        Method: 'post',
        Action: 'AzaInfo/GetShomareOzv',
        Token: this.$session.get('Token'),
      }

      this.$PostData(DataAxios_GetShomareOzv).then((data) => {
        if (data.status == 'Ok') {
          this.DataAxios.ShomareOzv = data.newShomare
        }
      })
      this.sarfasid = -1
      this.DataAxios = JSON.parse(JSON.stringify(this.Data))
      this.lightpenactive = false
    } else if (this.$route.params.Status == 'Edit') {
      this.InputActive = false
      this.DataAxios = JSON.parse(JSON.stringify(this.EditDataD))
      var tblCashImageIdPic
      var TblCashImageIdEmza1
      console.warn(this.EditData)
      if (this.EditData.TblCashImageIdPic != 0) {
        this.DataAxios_GetImg.Action = 'TblImageCash/Index'
        var formData = new FormData()
        formData.append('id', this.EditData.TblCashImageIdPic)
        this.DataAxios_GetImg.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_GetImg)
          .then((data) => {
            tblCashImageIdPic = data.img
          })
          .finally(() => {
            if (tblCashImageIdPic != null) {
              this.temp = 'data:image/png;base64,' + tblCashImageIdPic
            } else {
              this.temp = null
            }
          })
      }
      if (this.EditData.TblCashImageIdEmza1 != 0) {
        this.DataAxios_GetImg.Action = 'TblImageCash/Index'
        var formData = new FormData()
        formData.append('id', this.EditData.TblCashImageIdEmza1)
        this.DataAxios_GetImg.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_GetImg)
          .then((data) => {
            TblCashImageIdEmza1 = data.img
          })
          .finally(() => {
            if (TblCashImageIdEmza1 != null) {
              this.temp2 = 'data:image/png;base64,' + TblCashImageIdEmza1
            } else {
              this.temp2 = null
            }
          })
      }

      this.DataAxios = this.EditDataD
    }
  },
  methods: {
    OpenModal(num) {
      this.$store.state.Modal = true
      this.ModalSelect = num
    },
    AcceessButton(RoutName) {
      var menuBtn = this.$session.get('Menu')
      var GetParentRoute = menuBtn.filter((z) => z.RouteName == RoutName)
      var ButtonsRoute = menuBtn.filter((z) => z.ParentId == GetParentRoute[0].id)
      this.$session.set(RoutName, ButtonsRoute)
    },
    AzaPasAndJari(row) {
      try {
        row.TblAzaId = row.Id
        this.$router.push({ name: 'AzaPasAndJari', params: { AzaInfo: row } })
      } catch (error) {
        console.log(error)
      }
    },
    AzaTashilat(row) {
      try {
        row.TblAzaId = row.Id
        this.$router.push({ name: 'AzaTashilats', params: { AzaInfo: row } })
      } catch (error) {
        console.log(error)
      }
    },
    DeleteAza() {
      this.DataAxiosDelete.ArryfildValue = { id: this.EditData.Id }
      this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet)
    },
    Back() {
      this.$router.go(-1)
    },
    changeMode() {
      console.log('اصلاح')
      if (this.InputActive == false) {
        this.InputActive = true
      }
    },
    ValueResultMalekiat(val) {
      if (val.id!=null) {
        
      
      this.Malekiat = val.id
      this.DataAxios.TblComboIdMalekiat24 = val.id
    }
    },
    ValueResultHoze(val) {
      this.DataAxios.TblAzaNoeId = val.id
    },
    ValueResultVaziat(val) {
      this.DataAxios.TblComboIdVazeit12 = val.id
    },
    ValueResultNoeMoshtari(val) {
      this.DataAxios.TblTafsiliTypeId = val.id
    },
    ValueResultSex(val) {
      this.DataAxios.TblComboIdSex13 = val.id
    },
    ValueResultTaahol(val) {
      this.DataAxios.TblComboIdTahol19 = val.id
    },
    ValueResultTahsilat(val) {
      this.DataAxios.TblComboIdTahsilat316 = val.id
    },
    ValueResultJob(val) {
      this.DataAxios.TblJobsId = val.id
    },
    ValueResultMahalsodor(val) {
      this.DataAxios.TblComboIdMahalSodor11 = val.id
    },
    ResetForm(value) {
      this.$store.state[this.$route.name.substring(6)].Data[0] = value
      this.DataAxios = value
    },
    Openuploader(val) {
      document.getElementById(val).click()
    },
    changelightpen() {
      this.lightpenactive = true
    },
    showimage(event) {
      console.log('click')
      this.gellery = event.target.src
      document.getElementById('gallery').src = this.gellery
      document.getElementById('fullpage').style['display'] = 'block'
    },
    cancelgallery() {
      console.log('cancel')
      document.getElementById('fullpage').style['display'] = 'none'
    },
    AzaDlgsms() {
      try {
        // this.$store.state.Dlgsms.RowData[0]=row
        this.$router.push({ name: 'DlgSms' })
      } catch (error) {
        console.log(error)
      }
    },
    AzaHesabha(id) {
      this.$router.push({
        name: 'AzaHesabHa',
        params: { TblAzaId: id },
      })
    },
  },
  props: ['EditData'],
}
</script>
<style scoped>
#fullpage {
  display: none;
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100vw !important;
  min-height: 100vh !important;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-color: rgba(255, 255, 255, 0.679);
}
#gallery {
  max-width: 60%;
  max-height: 60%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20%;
  display: block;
}
.btn-Orange {
  background-color: #ff9800;
}

.badge-Orange {
  background-color: #ff9800;
}
.badge-Orange:hover {
  color: #000;
}
.badge-TurnOn-Webcam {
  border-radius: 20px;
  padding: 1%;
  border: 1px solid #8fb527;
  color: #000;
}

.badge-Out-Orange {
  color: #000;
  border: 2px solid #ff9800;
  background-color: #ffe9c8;
}

.img-circle.profile_img1 {
  border: 1px solid rgba(226, 131, 7, 0.44);
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  /* margin: 2px; */
  overflow: hidden;
  border: 0px;
  padding: 4px;
}
.profile_pic1 {
  height: 22vh;
  width: 22vh;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  border-radius: 100%;
  background: #fff;
  border: 2px solid #d17906;
}
.Shadow-DropDown {
  -webkit-box-shadow: 5px 7px 9px 1px rgba(10, 10, 10, 0.34);
  box-shadow: 5px 7px 9px 1px rgba(10, 10, 10, 0.34);
}
</style>
